export const IS_VX_APP = 10;
export const IS_VX_DATA_FIELD = 20;
export function getProductCategory(is_vx) {
    if (is_vx === null || is_vx === undefined || is_vx < 10) {
        return 'watchface';
    }
    if (is_vx >= 20) {
        return 'datafield';
    }
    return 'app';
}
export function isWatchfaceProduct(is_vx) {
    return getProductCategory(is_vx) === 'watchface';
}
export function getPaymentMode(is_vx) {
    if (is_vx === null || is_vx === undefined)
        return 0;
    return is_vx % 10;
}
/**
 * Liefert eine kompakte Versions-Kennzeichnung für Produktkarten/Übersicht,
 * damit VX/Elite schon vor dem Klick erkennbar ist.
 */
export function getVersionBadge(is_vx) {
    switch (getPaymentMode(is_vx)) {
        case 1:
            return 'combo'; // VX + Elite
        case 2:
            return 'elite'; // nur Elite / Garmin Pay
        case 3:
            return 'beta';
        default:
            return null;
    }
}
export function matchesHomePageFilter(is_vx, filter) {
    switch (filter) {
        case 'all':
            return true;
        case 'watchfaces':
            return isWatchfaceProduct(is_vx);
        case 'apps':
            return !isWatchfaceProduct(is_vx);
    }
}
